
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'
import axios from 'axios';
import { api_url,initSocket } from '../../utils/utils'
export const get_admin_dashboard_index_data = createAsyncThunk(
    'dashboard/get_admin_dashboard_index_data',
    async (_, { rejectWithValue, fulfillWithValue, getState }) => {
        // const { token } = getState().auth
        // const config = { headers: { Authorization: `Bearer ${token}` } }
        try {
            const { data } = await axios.get(`${api_url}/api/admin/get-dashboard-index-data`, {
                withCredentials: true,
            })
            // initSocket()  // Socket'u token ile başlat
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const get_seller_dashboard_index_data = createAsyncThunk(
    'dashboard/get_seller_dashboard_index_data',
    async (_, { rejectWithValue, fulfillWithValue, getState }) => {
        // const { token } = getState().auth
        try {
            const { data } = await axios.get(`${api_url}/api/seller/get-dashboard-index-data`, {
                withCredentials: true,
            })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

// Phase 8 — read-only daily orders/sales time-series for the dashboard
// trend chart. Failures resolve to an empty timeline so the home page never
// breaks because of a chart fetch.
export const get_admin_dashboard_timeseries = createAsyncThunk(
    'dashboard/get_admin_dashboard_timeseries',
    async ({ days = 30 } = {}, { fulfillWithValue }) => {
        try {
            const { data } = await axios.get(`${api_url}/api/admin/dashboard-timeseries?days=${days}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return fulfillWithValue({ timeline: [], days: 0 })
        }
    }
)
export const get_seller_dashboard_timeseries = createAsyncThunk(
    'dashboard/get_seller_dashboard_timeseries',
    async ({ days = 30 } = {}, { fulfillWithValue }) => {
        try {
            const { data } = await axios.get(`${api_url}/api/seller/dashboard-timeseries?days=${days}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return fulfillWithValue({ timeline: [], days: 0 })
        }
    }
)

export const dashboardIndexReducer = createSlice({
    name: 'dashboardIndex',
    initialState: {
        totalSale: 0,
        totalDigitalSale: 0,    // ✅ YENİ - admin digital satışları
        totalDigitalOrders: 0,  // ✅ YENİ - digital sifariş sayı
        totalOrder: 0,
        totalProduct: 0,
        totalSeller: 0,
        totalCommission: 0,
        marketplaceCommissionTotal: 0,
        pendingCommissionTotal: 0,
        totalSellerEarning: 0,
        totalPendingOrder: 0,
        recentOrders: [],
        recentMessage: [],
        // Seller üçün
        balance: 0,
        sellerOrders: [],
        sellerMessages: [],
        // Phase 8 — daily trend timeline (shared by admin + seller home charts).
        timeline: [],
        timelineLoader: false,
        adminLoader: false,
        adminError: '',
    },
    reducers: {
        prependRealtimeDashboardOrder: (state, { payload }) => {
            const authOrderId = payload.authOrderId || payload.orderId
            const exists = state.recentOrders.some(order => order._id === authOrderId)

            if (!exists) {
                state.recentOrders.unshift({
                    _id: authOrderId,
                    orderId: payload.customerOrderId || payload.orderId,
                    price: payload.totalPrice || payload.price || 0,
                    payment_status: 'Ödəniş olunmayıb',
                    delivery_status: 'Gözləmədə',
                    deliveryStatus: 'pending',
                    date: payload.createdAt
                        ? new Date(payload.createdAt).toLocaleString('az-AZ')
                        : new Date().toLocaleString('az-AZ'),
                    createdAt: payload.createdAt || new Date().toISOString()
                })
                state.recentOrders = state.recentOrders.slice(0, 5)
                state.totalOrder += 1
                state.totalPendingOrder += 1
            }
        },
        mergeRealtimeDashboardOrder: (state, { payload }) => {
            const authOrderId = payload.authOrderId || payload.orderId
            const customerOrderId = payload.customerOrderId

            state.recentOrders = state.recentOrders.map(order => {
                if (order._id !== authOrderId && order.orderId !== customerOrderId) {
                    return order
                }

                return {
                    ...order,
                    delivery_status: payload.sellerDeliveryStatus || payload.delivery_status || order.delivery_status,
                    deliveryStatus: payload.deliveryStatus || order.deliveryStatus,
                    isConfirmed: payload.isConfirmed ?? order.isConfirmed,
                    confirmedAt: payload.confirmedAt || order.confirmedAt,
                    sellerBalanceCredited: payload.sellerBalanceCredited ?? order.sellerBalanceCredited,
                    updatedAt: payload.updatedAt || new Date().toISOString()
                }
            })
        }
    },
    extraReducers: (builder) => {
        builder
            // Admin dashboard
            .addCase(get_admin_dashboard_index_data.pending, (state) => {
                state.adminLoader = true
                state.adminError = ''
            })
            .addCase(get_admin_dashboard_index_data.fulfilled, (state, { payload = {} }) => {
                state.adminLoader = false
                const data = payload || {}
                state.totalSale = data.totalSale || 0
                state.totalDigitalSale = payload.totalDigitalSale || 0   // ✅ YENİ
                state.totalDigitalOrders = payload.totalDigitalOrders || 0 // ✅ YENİ
                state.totalOrder = payload.totalOrder
                state.totalProduct = payload.totalProduct
                state.totalSeller = payload.totalSeller
                state.totalCommission = payload.totalCommission || 0
                state.marketplaceCommissionTotal = payload.marketplaceCommissionTotal || 0
                state.pendingCommissionTotal = payload.pendingCommissionTotal || 0
                state.recentOrders = payload.recentOrders
                state.recentMessage = payload.messages
                state.totalDigitalSale = state.totalDigitalSale || 0
                state.totalDigitalOrders = state.totalDigitalOrders || 0
                state.totalOrder = state.totalOrder || 0
                state.totalProduct = state.totalProduct || 0
                state.totalSeller = state.totalSeller || 0
                state.recentOrders = Array.isArray(state.recentOrders) ? state.recentOrders : []
                state.recentMessage = Array.isArray(state.recentMessage) ? state.recentMessage : []
            })
            .addCase(get_admin_dashboard_index_data.rejected, (state) => {
                state.adminLoader = false
                state.adminError = 'İdarəetmə panelinin məlumatları yüklənmədi.'
            })
            // Seller dashboard
            .addCase(get_seller_dashboard_index_data.fulfilled, (state, { payload = {} }) => {
                state.totalSale = payload.totalSale
                state.balance = payload.balance
                state.balanceComputed = payload.balanceComputed ?? payload.balance ?? 0
                state.balanceBreakdown = payload.balanceBreakdown || null
                state.pendingEscrowAmount = payload.pendingEscrowAmount || 0
                state.pendingEscrowCount = payload.pendingEscrowCount || 0
                state.totalCommission = payload.totalCommission
                state.totalSellerEarning = payload.totalSellerEarning || 0
                state.totalOrder = payload.totalOrder
                state.totalProduct = payload.totalProduct
                state.totalPendingOrder = payload.totalPendingOrder
                state.recentOrders = payload.recentOrders
                state.recentMessage = payload.messages
                state.totalSale = state.totalSale || 0
                state.balance = state.balance || 0
                state.totalCommission = state.totalCommission || 0
                state.totalOrder = state.totalOrder || 0
                state.totalProduct = state.totalProduct || 0
                state.totalPendingOrder = state.totalPendingOrder || 0
                state.recentOrders = Array.isArray(state.recentOrders) ? state.recentOrders : []
                state.recentMessage = Array.isArray(state.recentMessage) ? state.recentMessage : []
            })
            // Phase 8 — time-series (admin + seller share the same state slot).
            .addCase(get_admin_dashboard_timeseries.pending,  (state) => { state.timelineLoader = true })
            .addCase(get_admin_dashboard_timeseries.fulfilled, (state, { payload }) => {
                state.timelineLoader = false
                state.timeline = Array.isArray(payload?.timeline) ? payload.timeline : []
            })
            .addCase(get_seller_dashboard_timeseries.pending,  (state) => { state.timelineLoader = true })
            .addCase(get_seller_dashboard_timeseries.fulfilled, (state, { payload }) => {
                state.timelineLoader = false
                state.timeline = Array.isArray(payload?.timeline) ? payload.timeline : []
            })
    }
})

export const {
    prependRealtimeDashboardOrder,
    mergeRealtimeDashboardOrder
} = dashboardIndexReducer.actions

export default dashboardIndexReducer.reducer
